<script setup lang="ts">
/** Waiver of Pre-emption Rights (Transfer) — 기존 주주의 우선매수권 포기 동의서. */
import { computed, inject } from 'vue';
import { TRANSFER_DOC_CTX } from './transferContext';
import TransferDocVarField from './TransferDocVarField.vue';
import TransferTable from './parts/TransferTable.vue';
import TransferSigners from './parts/TransferSigners.vue';

const ctx = inject(TRANSFER_DOC_CTX)!;
const multi = computed(() => ctx.flag('is_multiple_member'));
const we = computed(() => (multi.value ? 'We' : 'I'));
const our = computed(() => (multi.value ? 'our' : 'my'));
const us = computed(() => (multi.value ? 'us' : 'me'));
const basisArticles = computed(() => ctx.choiceOf('resolution_basis') === 'articles');
function toggleBasis() {
  if (ctx.clauseLocked.value) return;
  ctx.setChoice('resolution_basis', basisArticles.value ? 'constitution' : 'articles');
}
</script>

<template>
  <div class="allot-doc">
    <p class="doc-p"><b>Date :</b> <TransferDocVarField field-key="letter_date" /></p>
    <p class="doc-p">The Board of Directors<br /><TransferDocVarField field-key="company_name" /><br />Registered Office</p>
    <p class="doc-p">Dear Sirs,</p>
    <p class="doc-p"><b><u>Consent to waive pre-emption rights - Transfer of Shares</u></b></p>
    <p class="doc-p">
      <span class="doc-toggle" title="single / multiple member (auto from members)" @click="ctx.toggleFlag('is_multiple_member')">{{ we }}</span>,
      being the existing member{{ multi ? 's' : '' }} of <TransferDocVarField field-key="company_name" /> do hereby raise no
      objections to the transfer of shares as detailed below and consent to waive {{ our }} pre-emption rights accorded to {{ us }} under the
      <span class="doc-toggle" :class="{ locked: ctx.clauseLocked.value }" title="Constitution / Articles" @click="toggleBasis">{{ basisArticles ? 'Articles of Association' : 'Constitution' }}</span>
      of the Company:-
    </p>

    <TransferTable />

    <p class="doc-p" style="margin-top:22px">Yours faithfully,</p>
    <TransferSigners var-key="waiver" />
  </div>
</template>

<style scoped>
.doc-toggle.locked { background:#eef2ff; box-shadow:inset 0 -2px 0 #9aa8d8; cursor:default; }
</style>
